import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_CMG_RESOLUTION_REQUEST,
  GET_CMG_RESOLUTION_SUCCESS,
  GET_CMG_RESOLUTION_FAILURE,
  GET_CMG_RESOLUTION_LOADING,
} = therapyPlanningAction;

function* getCmgResolution(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_CMG_RESOLUTION_LOADING });
    const response = yield call(therapyPlanningService.getCmgResolution, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_CMG_RESOLUTION_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_CMG_RESOLUTION_FAILURE, payload: error });
  }
}

function* getCmgResolutionSaga() {
  yield takeEvery(GET_CMG_RESOLUTION_REQUEST, getCmgResolution);
}

export default getCmgResolutionSaga;
